export default "__VITE_PUBLIC_ASSET__b8a058c4__"